<template>
  <Container></Container>
</template>

<script>
import { mapState } from 'vuex';
import Container from '@/components/Main/PersonalInfo/Container.vue';

export default {
  name: 'PersonalInfo',
  components: {
    Container,
  },
  computed: {
    ...mapState('contractor', { contractorId: (state) => state.id }),
  },
};
</script>

<style lang="stylus" scoped>
</style>
